import React from "react";
import type { ComponentType } from "react";
import type { EntryStatus } from "./lib/import-types";
import { cx } from "./ui";
import type { IconProps } from "./icons";

// Icon components in this module accept a `size` prop and use currentColor.
type IconComp = ComponentType<IconProps>;

export const KpiTile: React.FC<{
  icon: IconComp;
  label: string;
  value: string;
  tone?: "success" | "warning" | "danger" | "info";
  loading?: boolean;
}> = ({
  icon: Icon,
  label,
  value,
  tone,
  loading,
}) => {
  return (
    <div className="ih-kpi-tile">
      <div
        className={cx(
          "ih-kpi-label",
          tone === "success" && "ih-tone-success",
          tone === "warning" && "ih-tone-warning",
          tone === "danger" && "ih-tone-danger",
          tone === "info" && "ih-tone-info",
        )}
      >
        <Icon size={14} /> {label}
        {loading && (
          <span
            className="ih-spinner ih-kpi-spinner"
            role="status"
            aria-label="Loading"
          />
        )}
      </div>
      <div className="ih-kpi-value">{value}</div>
    </div>
  );
}

export const EntryStatusPill: React.FC<{ status: EntryStatus }> = ({ status }) => {
  const tone =
    status === "Cleared" ? "ih-badge-success" :
    status === "Detained" ? "ih-badge-danger" :
    status === "Hold" ? "ih-badge-warning" : "ih-badge-info";
  return <span className={cx("ih-badge", tone)}>{status}</span>;
}

// Re-export the icon prop type for convenience at call sites.
export type { IconProps };
